import React, { useEffect, useState } from 'react';
import ConsultasComunes from '../Sql/ConsultasComunes.js';
import MsgUtils from '../Tools/MsgUtils.js';
import ItemSucursalInventarioPredictivo from './ItemSucursalInventarioPredictivo.js';

function PrincipalInventarioPredictivo() {
    const [sucursales, setSucursales] = useState([]);
    const [selectSucursal, setSelectSucursal] = useState(-1);
    const [regional, setRegional] = useState('');
    const [tipo, setTipo] = useState('P');
    const [fecha, setFecha] = useState('');
    const [actualizar, setActualizar] = useState(true);
    const getInfo = async (regional) => {
        try {
            var resultado = await ConsultasComunes.getSucursales(regional);
            if (resultado.ok) {
                setSucursales(resultado.ok);
            } else {
                MsgUtils.msgError(resultado.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }

    useEffect(() => {
        if (sucursales.length == 0) {
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            setRegional(info.regional);
            getInfo(info.regional);
        }
    }, [])
    
    return (
        <>
            <div className='bg-dark bg-gradient container-fluid py-1'>
                <div className='row row-cols-2 gx-1'>
                    <div className='col-10'>
                        <div className='row row-cols g-1'>
                            <div className='col' style={{ minWidth:'200px',maxWidth: '200px' }}>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-transparent text-light mx-0 ">Sucursales</span>
                                    <select className="form-select" value={selectSucursal} onChange={(e) => setSelectSucursal(e.target.value)}>
                                        <option value={-1}>TODOS</option>
                                        {sucursales.map((item, index) => {
                                            return (<option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className='col' style={{ minWidth:'170px',maxWidth: '170px' }}>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-transparent text-light mx-0 ">Fecha</span>
                                    <input className='form-control' type='date' value={fecha} onChange={(e) => setFecha(e.target.value)}></input>
                                </div>
                            </div>
                            <div className='col' style={{ minWidth:'100px',maxWidth: '100px' }}>
                                <button className='btn btn-sm btnNaranja w-100' onClick={() => setActualizar(!actualizar)}>
                                    <i className="fa-solid fa-magnifying-glass"></i> Buscar</button>
                            </div>
                        </div>
                    </div>
                    <div className='col-2'>

                    </div>
                </div>
            </div>
            <hr className='text-light m-0'></hr>
            {sucursales.map((item, index) => {
                if (selectSucursal == -1 || selectSucursal == item.ID_SUCURSAL) {
                    return (<div className='container-fluid bg-dark bg-gradient mb-2' key={index}>
                        <div className='row row-cols-2 g-1'>
                            <div className='col'>
                                <div className='fw-bold text-light text-center'>{item.SUCURSAL}</div>
                            </div>
                            <div className='col'>
                                <div className='fw-bold text-light text-center'>{fecha}</div>
                            </div>
                        </div>
                        <ItemSucursalInventarioPredictivo info={item} regional={regional} tipo={tipo} fecha={fecha} actualizar={actualizar} setActualizar={setActualizar} />
                    </div>)
                }
            })}
        </>
    )
}

export default PrincipalInventarioPredictivo